export default function TypewriterScene({ sizeVideo }: { sizeVideo?: string }) {
  return (
    <div className="relative common-ui-main w-full h-full flex justify-center items-center">
      <video
        className="h-full w-full object-contain border-none"
        muted
        loop
        autoPlay
        playsInline
      >
        <source src={sizeVideo} type="video/mp4" />
      </video>
    </div>
  );
}
